export interface IMenuItem extends IMenuItemData{
  code:string,
  menu_name?:string
}
export interface IMenuItemData {
  icon: string
}
export const menuDefaultOrder = ['MENU_CONTRACTS','MENU_TASKS', 'MENU_DOCS','MENU_MARKETPLACE','MENU_FINANCE','MENU_USERS','MENU_STATISTIC',"MENU_PRODUCTION",'MENU_SETTINGS','MENU_TEMPLATE']
export const MenuItemsMap : Map<string,IMenuItemData> = new Map ([
  ['MENU_CONTRACTS',{icon:'file-chart-fill'}],
  ['MENU_TASKS',{icon:'task-fill'}],
  ['MENU_DOCS',{icon:'file-copy-2-fill'}],
  ['MENU_PRODUCTION',{icon:'git-repository-fill'}],
  ['MENU_MARKETPLACE',{icon:'shopping-cart-2-fill'}],
  ['MENU_FINANCE',{icon:'wallet-2-fill'}],
  ['MENU_USERS',{icon:'group-fill'}],
  ['MENU_STATISTIC',{icon:'pie-chart-2-fill'}],
  ['MENU_SETTINGS',{icon:'settings-3-fill'}],
  ['MENU_TEMPLATE',{icon:'file-2-fill'}]
])
export const menuPermissionsMap:Map<TPermissionGroup,string[]> = new Map([
    ['ALL', ['inner', 'dep_admin', 'proj_admin', 'outer']],
    ['ONLY_ADMIN', ['proj_admin']],
    ['INNER', ['inner', 'dep_admin', 'proj_admin']],
    ['BLOCKED', []]
]);
export type TPermissionGroup = 'ALL'|'ONLY_ADMIN'|'INNER'|'BLOCKED'

export const currentMenuUrls = {
    PROJECT_CONTRACTS: ['account', 'contracts', 'all','all_statuses'],
    MY_CONTRACTS: ['account', 'contracts', 'my','all_statuses'],
    PATTERNS: ['account', 'contracts', 'all','sample'],
    INCOMINGS_contracts: ['account', 'contracts', 'all','open'],
    ON_EXECUTION: ['account', 'contracts', 'all','verified'],
    COMPLITED: ['account', 'contracts', 'all','completed'],
    ARCHIEVED: ['account', 'contracts', 'all','closed'],

    MY_TASKS_MT: ['account', 'tasks2', 'my'],
    BOARDS: ['account', 'tasks', 'all'],
    MY_TASKS: ['account', 'tasks2', 'my'],
    SETTINGS: ['account', 'tasks', 'options'],
    LINKS_BETWEEN_BOARDS: ['account', 'tasks', 'boards'],

    DOCUMENTS: ['account', 'doc', 'nav'],
    INCOMING_DOCS: ['account', 'doc', 'inbox'],
    DOCUMENTS_APPROVAL: ['account', 'doc', 'approve'],
    SIGNED_DOCS: ['account', 'doc', 'signed'],
    DOCS_REGISTRY: ['account', 'doc', 'registry'],
    CUSTOM_FIELDS: ['account', 'doc', 'settings'],

    PRODUCTS: ['account', 'production', 'cards'],
    STORAGE: ['account', 'production', 'cargo'],
    CARGO_TRANSACTION: ['account', 'production', 'cargo_transaction'],

    DEMAND: [],
    SUPPLY: [],

    ACCOUNT: ['account', 'finance', 'accounts'],
    CREDITS: ['account', 'finance', 'credit'],
    FACTORING: ['account', 'finance', 'factoring'],
    BANK_GUARANTEE: ['account', 'finance', 'garant'],
    MY_WALLETS: ['account', 'finance', 'my'],

    EMPLOYEES_users: ['account', 'options', 'persons'],
    DEPARTMENTS: ['account', 'options', 'departments'],
    CONTRACTORS: ['account', 'options', 'departments'],

    EMPLOYEES_statistics: ['account', 'statistic', 'users'],
    TASKS_statistics: ['account', 'statistic', 'tasks'],
    FINANCES_statistics: ['account', 'statistic', 'finance'],
    CONTRACTS_statistics: ['account', 'statistic', 'contracts'],

    ASSIGNMENTS: ['account', 'assignments', 'all'],
};
export type TURLGroups = keyof typeof currentMenuUrls